import { PencilSquare, FileEarmarkText, Search } from 'react-bootstrap-icons';

export const introContent = {
  title: 'Welcome to NetZeroPlanner',
  subtitle: 'In partnership with NetZeroCities and Kausal',
};

export const benefits = [
  {
    icon: '/images/illustrations/undraw_order_a_car_-3-tww.svg',
    title: 'Tailored City Data',
    text: "Input your city's unique characteristics and strategic decarbonisation plans.",
  },
  {
    icon: '/images/illustrations/undraw_navigator_a479.svg',
    title: 'Decarbonisation Roadmap',
    text: "NetZeroPlanner generates a customised roadmap for your city's journey to climate neutrality.",
  },
  {
    icon: '/images/illustrations/undraw_term_sheet_re_ju7s.svg',
    title: 'Impact and Assessment',
    text: 'Evaluate costs, benefits, and returns across carbon sub-sectors and stakeholders, optimizing carbon reductions and comparing Euros invested.',
  },
  {
    icon: '/images/illustrations/undraw_join_re_w1lh.svg',
    title: 'Performance Tracking',
    text: 'Leverage annual performance reports to measure progress, ensuring your Climate Action Plans remain on track.',
  },
];

export const services = [
  {
    icon: PencilSquare,
    title: 'Sign up your city',
    text: 'Begin by signing up your city for NetZeroCities. Provide basic information to get started on your climate action journey.',
  },
  {
    icon: FileEarmarkText,
    title: 'Report city data',
    text: "Input relevant data about your city's emissions, climate initiatives, and progress. Utilize our intuitive reporting tools for accurate data representation.",
  },
  {
    icon: Search,
    title: 'Analyse and iterate',
    text: "Analyse your city's emission reduction potential using our powerful tools. Iterate and tweak strategies based on insights to maximise impact.",
  },
];
